"use strict";
// @ts-ignore
try {
    self['workbox:routing:5.1.4'] && _();
}
catch (e) { }
